import React, { Component } from 'react';
import propTypes from 'prop-types';
import i18n from './i18n';
import mergeI18n from '../../lib/util/merge-i18n';
import { LOG_IN_ROUTE } from '../../constants/constants';
import './_welcome.scss';

class Welcome extends Component {
	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem}`;

		return (
			<div id='welcome'>
				<div className='welcome-content-box'>
					<h1>{__.title}</h1>
					<h1>{__.title2}</h1>
					<h1>{__.title3}</h1>
					<div className='welcome-body'>
						{__.bodyText.map((text, index) => (
							<p key={index}>
								{text.split('\n').map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</p>
						))}
						<button
							tabIndex={0}
							id='submit-button'
							className='btn btn-primary'
							onClick={() => this.props.setRoute(LOG_IN_ROUTE)}
						>
							{__.scheduleButton}
						</button>
					</div>
				</div>
			</div>

		);
	}
}

Welcome.propTypes = {
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Welcome;
